<template>
    <popup
        class="range-picker"
        v-model="isShow"
        position="bottom">
        <picker
            ref="picker"
            :default-index="defaultIndex"
            show-toolbar
            :columns="range"
            @confirm="confirm"
            @cancel="close"
            :swipe-duration="300"></picker>
    </popup>
</template>

<script>
    import { Popup, Picker } from 'vant'
    import { MESSAGE_NAME } from '@/constants/message'
    import { sendMessage } from '@/utils/message_send'

    export default {
        name: 'RangePicker',
        components: {
            Popup,
            Picker
        },
        props: {
            name: {
                type: String,
                required: true
            },
            range: {
                type: Array,
                required: true,
                validator (value) {
                    return value.length > 0
                }
            },
            defaultIndex: {
                type: Number,
                required: false,
                default: 0
            }
        },
        data () {
            return {
                isShow: false
            }
        },
        methods: {
            confirm (value) {
                this.close()
                sendMessage({
                    type: 'base',
                    detailType: MESSAGE_NAME.TEXT,
                    content: value.toString()
                })
                this.reset()
            },
            close () {
                this.isShow = false
            },
            reset () {
                const defaultValue = this.range[this.defaultIndex]
                this.$refs.picker.setValues([defaultValue])
            }
        },
        created () {
            this.$eventBus.$on(`SHOW_${this.name}_PICKER`, () => {
                this.isShow = true
            })
        },
        beforeDestroy () {
            this.$eventBus.$off(`SHOW_${this.name}_PICKER`)
        }
    }
</script>
